import { url } from "@/data/site";
import PageShell from "@/components/PageShell";
import AboutHero from "@/components/about/AboutHero";
import AboutStudio from "@/components/about/AboutStudio";
import AboutCapabilities from "@/components/about/AboutCapabilities";
import AboutFounder from "@/components/about/AboutFounder";
import AboutSelectedWork from "@/components/about/AboutSelectedWork";
import AboutPerformance from "@/components/about/AboutPerformance";

const CANONICAL = url("/about");
const BASE = url("");
const DESCRIPTION =
  "Elentara is a creative technology studio building immersive web, 3D and interactive systems, founded by AK Padvnavam — programmer and former GitLab SOC analyst.";

const JSON_LD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "AboutPage",
      name: "About Elentara",
      url: CANONICAL,
      description:
        "Learn about Elentara — a creative technology studio building immersive digital experiences. Philosophy, approach, capabilities, performance and R&D.",
      isPartOf: { "@id": `${BASE}/#website` },
      about: { "@id": `${BASE}/#organization` },
      mainEntity: { "@id": `${CANONICAL}#founder` },
    },
    {
      "@type": "Person",
      "@id": `${CANONICAL}#founder`,
      name: "AK Padvnavam",
      jobTitle: "Founder, Programmer & Creative Technologist",
      description:
        "Programmer and former SOC analyst at GitLab, now founder of Elentara — a creative technology studio building immersive 3D web experiences.",
      url: CANONICAL,
      sameAs: ["https://x.com/AKPADVANAVAM"],
      alumniOf: { "@type": "Organization", name: "GitLab" },
      worksFor: { "@id": `${BASE}/#organization` },
      knowsAbout: [
        "WebGL",
        "Three.js",
        "Creative technology",
        "Security operations",
        "Front-end engineering",
      ],
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Elentara", item: `${BASE}/` },
        { "@type": "ListItem", position: 2, name: "About", item: CANONICAL },
      ],
    },
  ],
};

const ABOUT_SEO = {
  title: "About Elentara — Creative Technology Studio & Founder Story",
  description: DESCRIPTION,
  canonical: CANONICAL,
  jsonLd: JSON_LD,
};

export default function About() {
  return (
    <PageShell
      testId="about-page"
      finalCtaFrom="about"
      seo={ABOUT_SEO}
    >
      <AboutHero />
      <AboutStudio />
      <AboutCapabilities />
      <AboutPerformance />
      <AboutFounder />
      <AboutSelectedWork />
    </PageShell>
  );
}
